import React, { Component } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import LoadingCircle from '../../../components/common/loading/loading-circle'


// import styles from './styles';
class PaymentLoadingView extends Component {
  componentDidMount () {
    const { psPosId } = this.props.payments;
    if(psPosId == '') {
        this.props.ui.history.goBack();   
    }
  }
// componentDidMount() 
  render = () => {
      return (
        <LoadingCircle />
      );
  }
// constructor(props) { super(props); } 
// componentWillMount() {}
// componentWillReceiveProps(){} 
// shouldComponentUpdate(){} 
// componentWillUpdate(){} 
// componentDidUpdate(){} 
// componentWillUnmount(){} 

}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    ui: {
      history: {
        goBack: { $call: 'goBack' },
      }
    },
    payments: {
      psPosId: true
    }
  },
})(PaymentLoadingView);